import BenchlingConfig from 'BenchlingConfig';

export default function isRowOnlySubmissionRequired(structuredTable?: {
  metadata?: {rowByRowSubmissionRequired?: boolean};
}): boolean {
  return (
    BenchlingConfig.ELN_ENABLE_ROW_ONLY_TABLE_SUBMISSION &&
    structuredTable?.metadata?.rowByRowSubmissionRequired === true
  );
}
